import { render, staticRenderFns } from "./NotificationRecipients.vue?vue&type=template&id=c89d3ba4"
import script from "./NotificationRecipients.vue?vue&type=script&lang=ts"
export * from "./NotificationRecipients.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports